import React from "react";

import { IconName } from "../types";
import Icon from "./Icon";

const Selectable = (props: {
  selected?: boolean;
  hidden?: boolean;
  insetTick?: boolean; // Should the tick be inset from the edge instead of overlapping outside
  className?: string;
  children: JSX.Element;
}) => {
  return (
    <div
      className={`pyht-selectable ${props.className ? props.className : ""} ${
        props.selected ? "selected" : ""
      } ${props.insetTick ? "inset" : ""} ${props.hidden ? "hidden" : ""}`}
    >
      <>
        <Icon name={IconName.CHECK_MARK_CIRCLE} />
        {props.children}
      </>
    </div>
  );
};

export default Selectable;
